import { useSelector } from "react-redux";
import EqClassCodeList from "./EqClassCodeList";

const EqClassCodeListContainer = () => {

    const {
        eqClassCodeExample,
      }: any = useSelector(
        (state: any) => ({
            eqClassCodeExample: state.CatalogManagementReducer.eqClassCodeExample,
        })
      )


    return(
        <EqClassCodeList eqClassCodeExample={eqClassCodeExample}/>
    )
}

export default EqClassCodeListContainer;